import { render, staticRenderFns } from "./EditParticipant.vue?vue&type=template&id=01ec82b2"
import script from "./EditParticipant.vue?vue&type=script&lang=js"
export * from "./EditParticipant.vue?vue&type=script&lang=js"
import style0 from "./EditParticipant.vue?vue&type=style&index=0&id=01ec82b2&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports